<template>
    <div id="sign-in-form-1">
        <form @submit.prevent class="form-body">
            <div class="login-title">
                <p class="title is-3">{{ $t("Sign In") }}</p>
                <p style="margin-top: 7px">
                    {{ $t("New user?") }}
                    <router-link :to="{ name: 'sign-up' }">
                        <span
                            class="has-text-primary"
                            style="cursor: pointer; font-size: 20px"
                            >{{ $t("Create an account") }}</span
                        >
                    </router-link>
                </p>
            </div>
            <div
                class="level"
                style="margin-bottom: 0; display: flex; height: 450px"
            >
                <div
                    class="level-item"
                    style="flex-direction: column; width: 100%"
                >
                    <div class="input-container">
                        <label>{{ $t("Email") }}</label>
                        <custom-input
                            :placeholder="$t('Email')"
                            :capitalize="false"
                            :required="true"
                            @value="validateUsername($event)"
                            ref="username"
                        ></custom-input>
                        <p
                            v-if="error"
                            class="error"
                            ref="genError"
                            style="margin-top: 30px; text-align: center"
                        >
                            {{ $t(error) }}
                        </p>
                    </div>
                    <div style="display: flex; justify-content: center">
                        <Loading v-if="loading" />
                    </div>

                    <div
                        v-if="!loading"
                        style="
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                        "
                    >
                        <button
                            type="button"
                            class="auth-button"
                            @click="$router.push({ name: 'home' })"
                        >
                            {{ $t("Back") }}
                        </button>
                        <button
                            type="submit"
                            :class="[
                                'auth-button primary-btn',
                                { 'is-loading': loading },
                            ]"
                            style="border-radius: 10px"
                            :disabled="loading"
                            @click="continueSignIn"
                        >
                            {{ $t("Continue") }}
                        </button>
                    </div>
                </div>
            </div>
            <div
                class="form-footer form-gray"
                style="height: 40px; padding: 15px 0"
            >
                <p>
                    {{ $t("Protected by ALKOON and subject to our") }}
                    <a
                        target="_blank"
                        href="https://alkoonshipping.com/privacy_and_security.html"
                    >
                        <span class="has-text-primary" style="cursor: pointer">
                            {{ $t("Privacy Policy") }}
                        </span>
                    </a>
                    <span>{{ $t(" and ") }}</span>
                    <a
                        target="_blank"
                        href="https://alkoonshipping.com/terms_and_conditions.html"
                    >
                        <span class="has-text-primary" style="cursor: pointer">
                            {{ $t("Terms of Service.") }}
                        </span>
                    </a>
                </p>
            </div>
        </form>
    </div>
</template>

<script>
import CustomInput from "@/components/CustomInput.vue";
import patterns from "@/validations/patterns";
import Loading from "@/components/Loading";

export default {
    components: {
        Loading,
        "custom-input": CustomInput,
    },
    data() {
        return {
            user: {
                username: "",
            },
            loading: false,
            usernameError: false,
            error: false,
        };
    },
    watch: {
        "user.username"(val) {
            this.error = false;
        },
    },
    methods: {
        continueSignIn() {
            if (this.user.username === "" || this.usernameError) {
                return (this.error = "Please type your Email correctly");
            }
            this.loading = true;
            if (this.user.username != "") {
                this.$store
                    .dispatch("CHECK_EMAIL", {
                        email: this.user.username,
                    })
                    .then((res) => {
                        localStorage.setItem("email", this.user.username);
                        this.$router.push({
                            name: "sign-in-password",
                        });
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.error =
                            "Email not found, please create a new account";
                        this.loading = false;
                    });
            }
        },
        validateUsername(n) {
            this.user.username = n.trim();
            if (
                this.user.username.match(patterns.email) ||
                this.user.username.match(patterns.phone)
            ) {
                this.usernameError = false;
                this.$refs.username.validationError = false;
                this.$refs.username.messageError = "";
                return;
            } else {
                this.usernameError = true;
                this.$refs.username.validationError = true;
                this.$refs.username.messageError = this.$t(
                    "A valid email is required."
                );
            }
        },
    },
    mounted() {
        document.querySelectorAll(".input").forEach((input) => {
            input.setAttribute("style", "border-radius: 10px;");
        });
    },
};
</script>

<style lang="scss" scoped>
$error: #eb6174;

label {
    font-size: 14px;
    color: #000;
}

.login-title {
    padding: 5px 0 0;

    p {
        // color: white;
        text-align: left;
        margin: 0;

        &:first-of-type {
            font-size: 36px;
        }
    }
}

a {
    transition: 0️.4s;

    &:hover {
        text-decoration: underline;
    }
}

.error {
    color: $error;
}

.error.show {
    visibility: visible !important;
}

.help {
    color: $error !important;
}

#sign-in-form-1 {
    // margin-top: 50px;
    // width: 500px !important;
    // width: 100%;
    height: 100%;
    z-index: 1;

    .form-body {
        border-radius: 5px;
        text-align: center;
        margin: 10px 0;
        background-color: white;
        min-width: 500px;
        width: 500px;

        padding: 40px 50px;

        @media screen and (max-width: 600px) {
            padding: 40px 10px;
            min-width: 100%;
            width: 100%;
        }

        // height: 500px;
        display: inline-block;

        ::-webkit-input-placeholder {
            /* Edge */
            font-size: 14px;
        }

        :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            font-size: 14px;
        }

        ::placeholder {
            font-size: 14px;
        }

        .input-container {
            width: 100%;
            // min-width: 350px;
            margin-bottom: 60px;
        }

        .field:not(:last-child) {
            height: 75px;
        }

        .help {
            color: $error !important;
        }

        .label {
            text-align: left;
        }

        .control {
            width: 350px;
            display: inline-block;
        }

        .form-gray {
            color: #9b9b9b;
            font-size: 14px;
            text-align: center;
        }
    }
}
</style>
